import { usePollingQuery } from '../usePollingQuery'
import { fetchAutoPayStatus } from '../../repository/mfExecution'
import { useSearchParams } from 'react-router-dom'
import useTimer from '../useTimer'
import { AutoPaySetupStatus } from '../../types/mf-execution.types'

/** Polls GET .../sxp-mandate/status; reads optional upiPackageName from URL (v2 UPI autopay). */
export const useAutoPayStatusQuery = () => {
  const [searchParams] = useSearchParams()
  const sxpId = searchParams.get('sxpId')
  const mandateId = searchParams.get('mandateId')
  const upiPackageName = searchParams.get('upiPackageName')
  const { isExpired } = useTimer({ maxTimer: 120000 })
  const {
    data: autoPayStatus,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError,
    error
  } = usePollingQuery({
    queryKey: ['autoPayStatus', sxpId, mandateId, upiPackageName],
    queryFn: () =>
      fetchAutoPayStatus({
        sxpId: sxpId as string,
        mandateId: mandateId as string,
        upiPackageName,
      }),
    enabled: !!sxpId && !!mandateId,
    shouldPoll: (data, error) => {
      // Only poll if status is SETUP_PENDING and no error
      const currentStatus = data?.status
      const isInErrorState = error !== null
      return currentStatus === AutoPaySetupStatus.INITIATED && !isInErrorState && !isExpired
    },
    pollInterval: 2000
  })

  return {
    autoPayStatus,
    isError,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    error,
    isExpired
  }
}
